import { c as _c } from "react/compiler-runtime";
import { Text } from "@flat-ui";
/** Number of the annotations, e.g. "24 Annotations", or "3 of 24 Annotations" while some are hidden */
export function MarkupsCount(t0) {
  const $ = _c(10);
  const {
    shownCount,
    totalCount
  } = t0;
  const entityLabel = totalCount === 1 ? "Annotation" : "Annotations";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      whiteSpace: "nowrap"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== shownCount || $[2] !== totalCount) {
    t2 = shownCount !== totalCount && <><var>{shownCount}</var> of{" "}</>;
    $[1] = shownCount;
    $[2] = totalCount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== totalCount) {
    t3 = <var>{totalCount}</var>;
    $[4] = totalCount;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== entityLabel || $[7] !== t2 || $[8] !== t3) {
    t4 = <Text variant="bodyS" sx={t1}>{t2}{t3} {entityLabel}</Text>;
    $[6] = entityLabel;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}